var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-stacking-context": "true",
    "aria-owns": "html1",
    width: 50,
    height: 63,
    viewBox: "615 266 50 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "rootBackgroundAndBorders"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "childStackingContextsWithNegativeStackLevels"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "inFlowNonInlineNonPositionedDescendants"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "nonPositionedFloats"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "inFlowInlineLevelNonPositionedDescendants"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "childStackingContextsWithStackLevelZeroAndPositionedDescendantsWithStackLevelZero"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "childStackingContextsWithPositiveStackLevels"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-tag": "html",
    id: "html1",
    "data-z-index": "auto",
    "data-stacking-context": "true",
    "aria-owns": "head1 body1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-tag": "head",
    id: "head1",
    "data-z-index": "auto",
    "data-stacking-context": "true",
    "aria-owns": "meta1 title1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-tag": "meta",
    id: "meta1",
    "data-z-index": "auto",
    "data-stacking-context": "true"
  }), /*#__PURE__*/React.createElement("g", {
    "data-tag": "title",
    id: "title1",
    "data-z-index": "auto",
    "data-stacking-context": "true"
  })), /*#__PURE__*/React.createElement("g", {
    "data-tag": "body",
    id: "body1",
    "data-z-index": "auto",
    "data-stacking-context": "true",
    role: "document",
    "aria-owns": "img1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "rootBackgroundAndBorders"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 595.3333740234375,
    x: 0,
    y: 0,
    fill: "rgb(14, 14, 14)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-tag": "img",
    id: "img1",
    "data-z-index": "auto",
    "data-stacking-context": "true",
    role: "img",
    mask: "url(#mask-for-img11)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "rootBackgroundAndBorders"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: 608,
    y: 265.66668701171875,
    fill: "rgb(230, 230, 230)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "childStackingContextsWithNegativeStackLevels"
  }), /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "inFlowNonInlineNonPositionedDescendants"
  }), /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "nonPositionedFloats"
  }), /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "inFlowInlineLevelNonPositionedDescendants"
  }), /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "childStackingContextsWithStackLevelZeroAndPositionedDescendantsWithStackLevelZero"
  }), /*#__PURE__*/React.createElement("g", {
    "data-stacking-layer": "childStackingContextsWithPositiveStackLevels"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-for-img11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: 608,
    y: 265.66668701171875,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("image", {
    id: "img1-image",
    xlinkHref: "data:image/png;base64,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",
    x: 608,
    y: 265.66668701171875,
    width: 64,
    height: 64,
    "data-src": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/64px-HTML5_logo_and_wordmark.svg.png"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/HTML5.d8752317ea27b2dd6580fa41f953ef36.svg";
export { ForwardRef as ReactComponent };